document.addEventListener("DOMContentLoaded", function(event) {
  const sliderElem = document.querySelector('variant-radios .option-color-list');
  if (sliderElem){
      var pro_cat_slider = new Flickity( sliderElem, {
              cellAlign: 'left',              
              wrapAround: false,              
              contain: true,
              pageDots: false,
      });
  }
    
      function destroyFlickity() {
      if (pro_cat_slider) {
        pro_cat_slider.destroy();
        pro_cat_slider = null;
      }
    }

    function initFlickity() {
      pro_cat_slider = new Flickity(sliderElem, {
        cellAlign: 'left',
        contain: true,        
        wrapAround: false,  
        pageDots: false
      });
    }
    const tabs = document.querySelectorAll(".inner_label");
    const items = document.querySelectorAll(".inner_item");

    tabs.forEach(function (tab) {
      tab.addEventListener("click", function () {        
        tabs.forEach(t => t.classList.remove("active"));
        this.classList.add("active");
        const selectedCategory = this.getAttribute("data-label");        
        items.forEach(function (item) {
          const itemCategory = item.getAttribute("data-category");
          if (selectedCategory === "all") {
            item.style.display = "";
          } else {
            // Show item if its category includes selected tab (e.g., "red" in "red-rooted")
            if (itemCategory && itemCategory.includes(selectedCategory)) {
              item.style.display = "";
            } else {
              item.style.display = "none";
            }
          }
        });      
        let blockCount = 0;
        items.forEach(el => {
        if (getComputedStyle(el).display === 'block') {
        blockCount++;
        }
        });
        
        console.log("Total display:block elements:", blockCount);

        pro_cat_slider.reloadCells();
        pro_cat_slider.select(0);
         // Re-init Flickity
        // destroyFlickity();
        // initFlickity();
      });
    });

// =======================================
  const customSelect = document.querySelector(".custom-select");
                if (customSelect){
                      const selected = customSelect.querySelector(".selected");
                      const options = customSelect.querySelector(".select-options");    
                        selected.addEventListener("click", () => {
                        options.style.display = options.style.display === "block" ? "none" : "block";
                        });      
                        document.addEventListener("click", (e) => {
                        if (!customSelect.contains(e.target)) {
                        options.style.display = "none";
                        }
                        });
                }          

  const klarna_more = document.querySelector('#klarna_more') || null;
  if(klarna_more){
        setTimeout(() => {
          klarna_more.addEventListener('click', function() {
                const popupElement = document.querySelector('klarna-placement') || null;
                  if(popupElement){
                   const myButton = popupElement.shadowRoot.querySelector('button.link') || null; // Select element in shadowRoot inside the wrapper
                      if(popupElement){
                          myButton.click();
                      }
                  }
                });
        }, 3000);    
  }
const clearpay_more = document.querySelector('#afterpay_more') || null;
  if(clearpay_more){
        setTimeout(() => {
          clearpay_more.addEventListener('click', function() {
                const popupElement = document.querySelector('square-placement') || null;
                  if(popupElement){
                   const myButton = popupElement.shadowRoot.querySelector('button.afterpay-logo') || null; // Select element in shadowRoot inside the wrapper
                      if(popupElement){
                          myButton.click();
                      }
                  }
                });
        }, 3000);    
  }



















  // ==================================
  });